import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface DeleteButtonWithConfirmationProps {
  deleteCallback: () => void;
  deleteMessage?: string;
}

const RowDelete: React.FC<DeleteButtonWithConfirmationProps> = ({ deleteCallback, deleteMessage }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={(e) => e.stopPropagation()}
        >
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogDescription>
            {deleteMessage || 'Are you sure you want to delete this item? This action cannot be undone.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button 
              variant="ghost" 
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Cancel
            </Button>
          </DialogClose>
          <Button 
            variant="destructive" 
            onClick={(e) => {
              e.stopPropagation();
              deleteCallback();
            }}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RowDelete;
